// extracted by mini-css-extract-plugin
export default {"dashedButton":"SharedEmptyPicker-module__dashedButton--QErNO","hotkeyBadge":"SharedEmptyPicker-module__hotkeyBadge--sRhKV"};